import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    text: "We were really lost when our brother was diagnosed with autism. But at Sree Prathama, we got not just treatment—but also proper guidance. The doctors explained everything patiently and gave us a clear diet plan and routine. Our brother is now more calm, less cranky, and we feel more confident as parents. Thank you so much for standing with us.",
    name: "Hari Karanam",
  },
  {
    text: "We consulted Dr. Santhisree for my 7-year-old son, who was diagnosed with ADHD. After starting the medication and diet recommended by her, we noticed a significant improvement in his behavior. We've received positive feedback from his school as well, noting that he has been focusing better and his sitting tolerance has improved. His reasoning and cognitive skills have also seen a marked enhancement. We are truly grateful to Dr. Santhisree for her guidance and support.",
    name: "Simran Singh",
  },
  {
    text: "Our 8-year-old daughter was diagnosed with both autism and ADHD, and it has been a challenging journey for our family. We decided to consult Dr. Santhisree, and it turned out to be the best decision we made. The combination of Ayurvedic medicines, dietary adjustments, and Panchakarma therapies have brought about significant improvements in our daughter's behavior and cognitive abilities. She is now more focused, her communication skills have improved, and she's more socially engaged. We are immensely grateful to Dr. Santhisree and her team for their dedicated care and support.",
    name: "Vedprakash Sharma",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[#FAF7F2] py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <Eyebrow>
            <span className="mx-auto">Chapter 09 · Parent Voices</span>
          </Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight leading-tight">
            What Parents Want Most: To Understand Their Child Better.
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="h-full bg-[#F4EFE6] rounded-3xl p-8 border border-[#E5D3AD]/40 hover:border-[#C5A059] transition-colors duration-500 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <Quote className="w-7 h-7 text-[#C5A059] fill-[#C5A059]" />
                  <span className="text-[10px] font-semibold tracking-[0.22em] uppercase text-[#B85D43]">
                    Parent Experience
                  </span>
                </div>
                <blockquote className="mt-6 flex-1 text-sm text-[#2D3A32] leading-relaxed">
                  "{t.text}"
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-[#E5D3AD]/60 font-serif text-lg text-[#1B3B2B]">
                  — {t.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
